import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Columns, Text } from '@deseretbook/react-ui'

/**
 * Item added to cart info.
 *
 * @param {object} props - Component props.
 * @returns {function} Component
 */
function ItemAddedCart(props) {
  const { order } = props
  const totalItems = order.lineItems.reduce((sum, item) => sum + item.quantity, 0)
  const itemWording = totalItems === 1
    ? 'item'
    : 'items'

  return (
    <Box paddingVertical={1}>
      <Box paddingBottom={1}>
        <Text display="block" alignment="center" size="large">
          Subtotal ({totalItems} {itemWording}) <Text size="large" isBold>{order.displayItemTotal}</Text>
        </Text>
      </Box>
      <Button
        as="a"
        href="/checkout"
        color="action"
        isFullwidth
        >
          Proceed To Checkout
      </Button>
      <Box paddingVertical={1}>
        <Columns isMobile>
          <Columns.Column>
            <Button
              as="a"
              href="/products"
              isFullwidth
              >
                Continue Shopping
            </Button>
          </Columns.Column>
          <Columns.Column>
            <Button
              as="a"
              href="/cart"
              isFullwidth
              >
                View Cart
            </Button>
          </Columns.Column>
        </Columns>
      </Box>
    </Box>
  )
}

ItemAddedCart.defaultProps = {
  order: {},
}

ItemAddedCart.propTypes = {
  // The order being placed
  order: PropTypes.shape({
    displayItemTotal: PropTypes.string,
    lineItems: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}

export default ItemAddedCart
